{
  "home_page": {
    "header": {
      "title_complete": "👋 Welcome back, {firstName}!",
      "title_incomplete": "🚀 Let's get started with SparkLayer, {firstName}!",
      "description_complete": "Here's how your B2B store is doing.",
      "description_incomplete": "Work through these steps to start selling B2B.",
      "setup_assistance": "Free setup assistance",
      "watch_tour": "Watch tour"
    },
    "onboarding_progress": {
      "title": "Onboarding progress"
    },
    "all_set": {
      "title": "You're all set up with SparkLayer!",
      "description": "You can check and configure your integration at any point within the Settings section."
    },
    "footer": "Learn more about SparkLayer"
  },
  "settings_setup_page": {
    "header": {
      "title": "Setup",
      "description": "You're configuring SparkLayer for your {environment} website",
      "footer": "Learn more about getting started",
      "invite_partner": "Invite technical partner"
    }
  }
}
